"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UITileSection = _interopRequireDefault(require("UIComponents/tile/UITileSection"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _partial = _interopRequireDefault(require("transmute/partial"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin: 3px 0px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    min-width: unset;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-bottom: 15px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: ", ";\n    margin: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// growthSuitePage bool prop passed down to change size styling when HsfsCard is on GrowthSuitePage vs Marketing/Sales/Service Hub tabs
var StyledUITile = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "HsfsCard__StyledUITile",
  componentId: "sc-1t6fpnm-0"
})(["margin-top:", ";width:100%;max-width:", ";", ";", ";"], function (props) {
  return !props.growthSuitePage && '25px';
}, function (props) {
  return props.growthSuitePage && '1100px';
}, _responsiveBreakpoints.default.tabletPortrait(_templateObject(), function (props) {
  return !props.growthSuitePage && '80%';
}, function (props) {
  return !props.growthSuitePage && '20px auto 20px';
}), _responsiveBreakpoints.default.phone(_templateObject2(), function (props) {
  return !props.growthSuitePage && '90%';
}));
var StyledUIMultiColumnItem = (0, _styledComponents.default)(_UIMultiColumnItem.default).withConfig({
  displayName: "HsfsCard__StyledUIMultiColumnItem",
  componentId: "sc-1t6fpnm-1"
})(["", ";"], _responsiveBreakpoints.default.phoneLarge(_templateObject3()));

var CTAContainer = _styledComponents.default.div.withConfig({
  displayName: "HsfsCard__CTAContainer",
  componentId: "sc-1t6fpnm-2"
})(["min-width:315px;", ";"], _responsiveBreakpoints.default.cs(_templateObject4()));

var StyledButton = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "HsfsCard__StyledButton",
  componentId: "sc-1t6fpnm-3"
})(["width:140px;", ""], _responsiveBreakpoints.default.cs(_templateObject5()));

var HsfsCard = function HsfsCard(props) {
  var onButtonClick = function onButtonClick(url) {
    (0, _getUsageTracker.default)().track('externalLinkClick', {
      name: 'hsfs',
      url: url
    });
  };

  return _react.default.createElement(StyledUITile, {
    compact: true,
    growthSuitePage: props.growthSuitePage
  }, _react.default.createElement(_UITileSection.default, null, _react.default.createElement(_UIMultiColumn.default, {
    flush: true
  }, _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(StyledUIMultiColumnItem, null, _react.default.createElement(_H.default, {
    style: {
      fontWeight: 'bold',
      marginBottom: '4px'
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.hsfsCard.header"
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.hsfsCard.discountMessage"
  }))), _react.default.createElement(_UIMultiColumnItem.default, null, _react.default.createElement(CTAContainer, null, _react.default.createElement(_EnvironmentWrapper.default, {
    authedNode: _react.default.createElement(StyledButton, {
      use: "tertiary",
      href: (0, _urls.getHSFSApplicationURL)(),
      target: "_blank",
      onClick: (0, _partial.default)(onButtonClick, (0, _urls.getHSFSApplicationURL)()),
      truncate: true
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.hsfsCard.applyButton"
    }))
  }), _react.default.createElement(StyledButton, {
    use: "tertiary-light",
    href: (0, _urls.getHubspotForStartupsLandingPageUrl)('dot-com-pricing'),
    target: "_blank",
    onClick: (0, _partial.default)(onButtonClick, (0, _urls.getHubspotForStartupsLandingPageUrl)('dot-com-pricing')),
    truncate: true
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.hsfsCard.learnButton"
  }))))))));
};

var _default = HsfsCard;
exports.default = _default;
module.exports = exports.default;